import { itemCategoryAddApi } from "../../api/itemCategory/itemCategoryAddApi"

type PayloadShape = Parameters<typeof itemCategoryAddApi>[0]

export async function itemCategoryAddService(payload: PayloadShape, token: string) {
	return await itemCategoryAddApi(payload, token)
}
